import axios from "axios";
import siteUrl from "./const";
import store from "../redux/store";
export const aictia = axios.create({
  baseURL: `${siteUrl}`,
  headers: { "Content-Type": "application/json" },
});

aictia.interceptors.request.use(
  (config) => {
    localStorage.getItem("locale")
    config.headers["Authorization"] = localStorage.getItem("access_token")
      ? "Bearer " + localStorage.getItem("access_token")
      : null;
    config.headers["Accept-Language"] = localStorage.getItem("locale")
      ? localStorage.getItem("locale")
      : "az";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);




// kef ele supersen
aictia.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data || "An unknown error occurred";
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
    store.dispatch({ type: "LOG_OUT" }); 
      window.location.href = "/";
    }

    return Promise.reject(errorMessage);
  }
);


export default aictia;
